import { useToast } from '@chakra-ui/toast';
import { useNavigate } from 'react-router';

import { AuthLayout } from '../components/AuthLayout';
import { FirstAccessForm } from '../components/FirstAccessForm';

export const FirstAccessPage = () => {
  const toast = useToast();
  const navigate = useNavigate();

  return (
    <AuthLayout title="Primeiro acesso">
      <FirstAccessForm
        onSuccess={() => {
          navigate('/login');
          toast({
            title: 'Senha criada com sucesso!',
            status: 'success',
            duration: 5000,
            isClosable: true,
          });
        }}
        onError={() => {
          toast({
            title: 'Credenciais inválidas!',
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
        }}
      />
    </AuthLayout>
  );
};
